import { SYN_API_URLS } from '@/constants/api';
import SentryService from '@/entities/SentryService';
import { IChainState, setChainTokenInfos } from '@/features/chain/chainSlice';

import { useAppDispatch } from '@/hooks';
import { ConfigApiResponse } from '@/types/config';
import { TokenInfo } from '@/types/token';
import { axiosGet } from '@/utils/axios';
import _ from 'lodash';
import { useCallback, useEffect } from 'react';
import { useConfigData } from '../hook';
import { setConfigApiResponse, setIsConfigApiResponseFetched } from '../slice';

function useFetchConfigData() {
  const dispatch = useAppDispatch();
  const { chainTokensInfoConfig, backendChainsConfig } = useConfigData();
  const fetchConfigData = useCallback(async () => {
    try {
      const respose = (await axiosGet({ url: SYN_API_URLS.COMMON.DAPP_CONFIG }))?.data;
      const configApiResponse = (respose?.perp || respose) as ConfigApiResponse;
      dispatch(setConfigApiResponse({ configApiResponse }));
      return [];
    } catch (error) {
      SentryService.captureException(error, { name: SYN_API_URLS.COMMON.DAPP_CONFIG });
      dispatch(setIsConfigApiResponseFetched(false));
      console.log(error);
      return [];
    }
  }, [dispatch]);

  useEffect(() => {
    const chainTokenInfos = _.reduce(
      Object.entries(chainTokensInfoConfig),
      (acc, [chainId, config]) => {
        acc[Number(chainId)] = {
          tokens: config.erc20Tokens?.reduce((acc, token) => {
            acc[token.address.toLowerCase()] = token;
            return acc;
          }, {} as { [tokenId: string]: TokenInfo }),
        };
        return acc;
      },
      {} as IChainState['chainTokenInfos'],
    );
    dispatch(setChainTokenInfos({ chainTokenInfos }));
  }, [chainTokensInfoConfig]);

  useEffect(() => {
    fetchConfigData();
  }, [dispatch, fetchConfigData]);
}

export default function ConfigGlobalEffect(): null {
  useFetchConfigData();
  return null;
}
